import useIsNewStep from '@/hooks/useIsNewStep.ts';
import { useMemo } from 'react';
import { ConfigFieldError, ConfigFieldValue } from '@/types/automationFields.ts';

function useFieldConfigError(
  stepId: string | undefined,
  fieldValueConfig: ConfigFieldValue,
): ConfigFieldError | undefined {
  const isNewStep = useIsNewStep(stepId);

  return useMemo(() => {
    if (isNewStep) {
      return undefined;
    }
    return fieldValueConfig.errors.length > 0 ? fieldValueConfig.errors[0] : undefined;
  }, [fieldValueConfig.errors, isNewStep]);
}

export default useFieldConfigError;
